import { ISupportedDeviceType } from '@/content/components/pages/Session/types';

const APP_ENVS = ['local', 'dev', 'staging', 'prod'] as const;

const appEnv = import.meta.env.VITE_APP_ENV;

if (!appEnv || !APP_ENVS.includes(appEnv)) {
  throw new Error(
    `Environment variable not set or invalid: VITE_APP_ENV (expected one of: ${APP_ENVS.join(', ')})`,
  );
}

const ENV_VARIABLES = {
  VITE_APP_ENV: appEnv,
  VITE_AWS_HOLOXR_FRONTENDWEB_USERPOOLCLIENT_ID:
    import.meta.env.VITE_AWS_HOLOXR_FRONTENDWEB_USERPOOLCLIENT_ID,
  VITE_FRONTENDWEB_BASEURL: import.meta.env.VITE_FRONTENDWEB_BASEURL,
  VITE_AWS_HOLOXR_FRONTENDWEB_USERPOOLCLIENT_URL:
    import.meta.env.VITE_AWS_HOLOXR_FRONTENDWEB_USERPOOLCLIENT_URL,
  VITE_AWS_HOLOXR_BACKEND_API_BASEURL: import.meta.env.VITE_AWS_HOLOXR_BACKEND_API_BASEURL,
  VITE_AWS_USERS_BACKEND_API_BASEURL: import.meta.env.VITE_AWS_USERS_BACKEND_API_BASEURL,
  ENV_DEV: appEnv === 'dev' || appEnv === 'local',
  ENV_STAGE: appEnv === 'staging',
  ENV_PROD: appEnv === 'prod',
  VITE_LIVESWITCH_APP_ID: import.meta.env.VITE_LIVESWITCH_APP_ID,
} as const;

const COMMON_ERRORS = {
  UNEXPECTED_ERROR: 'Unexpected error',
} as const;

/** authorizer code when a user is outside their weekly access window. */
const API_ERROR_CODES = {
  USAGE_TIME_LIMIT:
    'lambda_authorizer.authorizeLambda.authorization.usage_time_limit',
} as const;

const QUERY_KEYS = {
  USER: 'user',
  PROFILE_AVATAR_PRESIGNED_URL: 'profileAvatarPresignedUrl',
  ALL_USER: 'users',
  ALL_ORGANIZATIONS: 'organizations',
  ORGANIZATION_DETAILS: 'organization-details',
  USERS_SESSIONS_INFINITE: 'user-sessions-infinite',
  USERS_SESSIONS: 'user-sessions',
  INVITATIONS: 'invitations',
  MY_MEDIA: 'my-media',
  MY_MEDIA_INFINITE: 'my-media-infinite',
  MY_MEDIA_ACCESS_USERS: 'my-media-access-users',
  PRIVATE_MEDIA_PRESIGNED_UPLOAD_URL: 'privateMediaPresigneUploaddUrl',
  PRIVATE_MEDIA_PRESIGNED_DOWNLOAD_URL: 'privateMediaPresignedDownloadUrl',
  ORGANIZATION_USERS: 'organization-users',
  ORGANIZATIONS_LICENSES: 'organizations-licenses',
  LICENSE: 'license',
} as const;

const PARTICIPANT_ROLES = {
  LEADER: 'leader',
  CO_LEADER: 'coleader',
  CONTRIBUTOR: 'contributor',
  VIEWER: 'viewer',
  HEADLESS: 'headless',
} as const;

const PARTICIPANT_ROLES_EXCLUDING_LEADER = {
  CO_LEADER: 'coleader',
  CONTRIBUTOR: 'contributor',
  VIEWER: 'viewer',
} as const;

const VIEW_MODE = {
  VIEW_ALL: 'ViewAll',
  VIEW_LOCAL_PINNED: 'ViewLocalPinned',
  VIEW_GLOBAL_PINNED: 'ViewGlobalPinned',
} as const;

const LICENSE_TYPE = {
  ALL: 'all', // not a real license type, used for filtering
  ENTERPRISE: 'enterprise',
  PREMIUM: 'premium',
  BASIC: 'basic',
  UNLICENSED: 'unlicensed',
} as const;

const PLATFORM_ROLE_TYPE = {
  USER: 'user',
  PLATFORM_ADMIN: 'platformAdmin',
  PLATFORM_AUDITOR: 'platformAuditor',
  PLATFORM_SUPPORT: 'platformSupport',
  ORG_OWNER: 'orgOwner',
  ORG_ADMIN: 'orgAdmin',
} as const;

const DEVICE_TYPES: ISupportedDeviceType[] = ['web', 'screen', 'xr', 'hp', 'vuzix'];

const SESSION_STORAGE_KEYS = {
  REDIRECT_PATH: 'REDIRECT_PATH',
} as const;

const PUBLIC_ASSETS_URLS = {
  HEALTHCONNECT_LOGO: '/static/images/logo/holoxr_healthconnect_logo.svg',
  HEALTHCONNECT_LOGO_NEGATIVE: '/static/images/logo/holoxr_healthconnect_logo_negative.svg',
  HERO_VIDEO_WEBM: '/static/video/hero-video.webm',
  HERO_VIDEO_MP4: '/static/video/hero-video.mp4',
  HER_VIDEO_POSTER: '/static/covers/hero-poster.webp',
} as const;

const LOCALE_CONFIG = {
  SUPPORTED_LANGUAGES: ['en', 'fr'],
  NAMESPACES: ['common', 'errors', 'legal', 'profile', 'dashboard', 'sessionDashboard', 'myMedia', 'home', 'session', 'organization', 'licenseManagement', 'userManagement'],
} as const;

export {
  ENV_VARIABLES, COMMON_ERRORS, API_ERROR_CODES, QUERY_KEYS, PARTICIPANT_ROLES, VIEW_MODE,
  PARTICIPANT_ROLES_EXCLUDING_LEADER,
  LICENSE_TYPE,
  PLATFORM_ROLE_TYPE,
  SESSION_STORAGE_KEYS,
  DEVICE_TYPES,
  PUBLIC_ASSETS_URLS,
  LOCALE_CONFIG,
};
